import { useEffect, useRef } from "react";
import { useFrame } from "@react-three/fiber";

export const INITIAL_FRAME_COUNT = 12;

export function InitialFrameSignal({ onMount, onProgress, onReady }) {
  const firedRef = useRef(false);
  const frameCountRef = useRef(0);

  useEffect(() => {
    onMount?.(100);
  }, [onMount]);

  useFrame(() => {
    frameCountRef.current += 1;
    if (frameCountRef.current <= INITIAL_FRAME_COUNT) {
      onProgress?.(frameCountRef.current);
    }
    if (!firedRef.current && typeof onReady === "function") {
      if (frameCountRef.current < INITIAL_FRAME_COUNT) return;
      firedRef.current = true;
      onReady();
    }
  });

  return null;
}
